import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/isolation-mode.svg'


const _hoisted_1 = {
  id: "modal-wrong-credentials-sis-ar",
  class: "modal modal-md fade",
  tabindex: "-1"
}

import { Modal } from 'bootstrap'
  import { ref, onMounted } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalWrongCredentialsSisAr',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  onMounted(() => {
    modal.value = new Modal('#modal-wrong-credentials-sis-ar', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "modal-dialog modal-dialog-centered" }, [
      _createElementVNode("div", { class: "modal-content" }, [
        _createElementVNode("div", { class: "modal-header pb-3" }, [
          _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Usuário ou senha inválidos", -1)),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: hide
          })
        ]),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"modal-body py-3\" data-v-67135404><img alt=\"modo de isolamento\" src=\"" + _imports_0 + "\" data-v-67135404><div class=\"mt-5\" data-v-67135404><p class=\"fs-6 text-start\" data-v-67135404><strong data-v-67135404>Ops! Parece que os dados inseridos não estão corretos.</strong></p><p class=\"fs-6 text-start pt-3\" data-v-67135404> Por favor, verifique seu usuário e senha de emissão e tente novamente. </p></div></div><div class=\"modal-footer py-3\" data-v-67135404><button class=\"btn btn-primary\" type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-67135404> Tentar novamente </button></div>", 2))
      ])
    ])
  ]))
}
}

})